export default __webpack_public_path__ + "static/media/arrow.3cc1d722.svg";